var module = angular.module('octopusApp.environments');

module.controller('ProxyEditController', function ($scope, $stateParams, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    $scope.view = {};
    $scope.view.hasExistingPassword = false;
    $scope.view.showPasswordChange = true;

    var proxyId = $stateParams["id"];

    $scope.proxy = null;

    isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function (status) {
        $scope.status = status;

        if (proxyId) {
            isLoading.promise(octopusRepository.Proxies.get(proxyId).then(function (result) {
                $scope.proxy = result;
                if (!result.Password) {
                    result.Password = {HasValue: false};
                }
                if (!result.Username) {
                    $scope.view.showPasswordChange = true;
                    $scope.view.hasExistingPassword = false;
                } else {
                    $scope.view.hasExistingPassword = true;
                    $scope.view.showPasswordChange = false;
                }
                pageTitle($scope.proxy.Name);
            }));
        } else {
            $scope.proxy = {ProxyType: 'HTTP'};
            pageTitle("Create proxy");
        }

        $scope.deleteProxy = function () {
            var dlg = octoDialog.confirmDelete('proxy', function () {
                return octopusRepository.Proxies.del($scope.proxy);
            });
            dlg.then(function (result) {
                if (result) {
                    unsavedChanges.saved();
                    $location.path("/environments/proxies");
                }
            });
        };
    }));

    $scope.save = function () {
        isSaving.promise(octopusRepository.Proxies.save($scope.proxy).then(function (result) {
            unsavedChanges.saved();
            $location.path("/environments/proxies");
        }));
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/proxies/controllers/proxy_edit_controller.js
// module id = 1372460388972787
// module chunks = 1